<template>
  <CRow>
    <CCol>
      <CCard>
        <div class="judul">
          <strong>Detail Pengajuan</strong>
        </div>
        <CCardHeader>
          <strong>Data Diri Pendaftar</strong>
        </CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="ID Registration"
                class="mb-0"
                placeholder="ID Registration"
                v-model.trim="agentData.agent_id"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Bentuk Pengajuan"
                class="mb-0"
                placeholder="Bentuk Pengajuan"
                v-model.trim="agentData.registration_type"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Nama Pendaftar"
                class="mb-0"
                placeholder="Nama Pendaftar"
                v-model.trim="agentData.register_name"
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Alamat Pendaftar"
                class="mb-0"
                placeholder="Alamat Pendaftar"
                v-model.trim="agentData.register_address"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="No HP"
                class="mb-0"
                placeholder="NO HP"
                v-model.trim="agentData.phone_number"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Email Pendaftar"
                class="mb-0"
                placeholder="Email Pendaftar"
                v-model.trim="agentData.register_email"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="No HP2"
                class="mb-0"
                placeholder="NO HP2 "
                v-model.trim="agentData.phone_number_two"
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Darimana Anda mendapatkan informasi tentang pendaftaran ini"
                class="mb-0"
                v-model.trim="agentData.resource"
                disabled
              />
            </CCol>
          </CRow>
        </CCardBody>

        <CCardHeader v-if="agentData.registration_type === 'Badan Usaha'">
          <strong>Data Perusahaan</strong>
        </CCardHeader>
        <CCardBody v-if="agentData.registration_type === 'Badan Usaha'">
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Jenis Perusahaan"
                class="mb-0"
                placeholder="Jenis Perusahaan"
                v-model.trim="agentData.company_type"
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Nama ketua perusahaan"
                class="mb-0"
                placeholder="Nama ketua perusahaan"
                v-model.trim="agentData.company_chairman_name"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Nama Perusahaan"
                class="mb-0"
                placeholder="Nama Perusahaan"
                v-model.trim="agentData.company_name"
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Alamat Perusahaan"
                class="mb-0"
                placeholder="Alamat Perusahaan"
                v-model.trim="agentData.company_address"
              />
            </CCol>
          </CRow>
        </CCardBody>

        <CCardHeader>
          <strong>Data Lokasi</strong>
        </CCardHeader>

        <CCardBody>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Lokasi"
                class="mb-0"
                placeholder="Lokasi"
                v-model.trim="agentData.building_location"
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Jenis Bangunan"
                class="mb-0"
                placeholder="Jenis Bangunan"
                v-model.trim="agentData.building_type"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Status Bangunan"
                class="mb-0"
                placeholder="Status Bangunan"
                v-model.trim="agentData.building_status"
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Alamat Lokasi"
                class="mb-0"
                placeholder="Alamat Lokasi"
                v-model.trim="agentData.address_location"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Provinsi"
                class="mb-0"
                placeholder="Provinsi"
                v-model.trim="agentData.province"
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Kota"
                class="mb-0"
                placeholder="Kota"
                v-model.trim="agentData.district"
              />
            </CCol>
          </CRow>

          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Kecamatan"
                class="mb-0"
                placeholder="Kecamatan"
                v-model.trim="agentData.sub_district"
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Kelurahan"
                class="mb-0"
                placeholder="Kelurahan"
                v-model.trim="agentData.village"
              />
            </CCol>
          </CRow>
        </CCardBody>

        <CCardHeader> </CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Apakah bersedia pickup ke customer?"
                class="mb-0"
                placeholder="Apakah bersedia pickup ke customer?"
                v-model.trim="isPickup"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Apakah ada pengalaman di bidang pengiriman/logistik?"
                class="mb-0"
                placeholder="Apakah ada pengalaman di bidang pengiriman/logistik?"
                v-model.trim="isLogistic"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Apakah ada kenalan online shop di wilayah anda?"
                class="mb-0"
                placeholder="Apakah ada kenalan online shop di wilayah anda?"
                v-model.trim="isLogistic"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Latitude & Longitude"
                class="mb-0"
                placeholder="Latitude & Longitude"
                v-model.trim="agentData.latlong"
              />
            </CCol>
          </CRow>
          <CRow class="form-group align-items-end">
            <CCol :col="6">
              <CInput
                label="Apakah bersedia melakukan drop off paket ke shuttle / konsolidator terdekat?"
                class="mb-0"
                placeholder="Apakah bersedia melakukan drop off paket ke shuttle / konsolidator terdekat?"
                v-model.trim="isDropOff"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Apakah bersedia melakukan Top Up pertama senilai Rp. 5.000.000?"
                class="mb-0"
                placeholder="Apakah bersedia melakukan Top Up pertama senilai Rp. 5.000.000?"
                v-model.trim="isTopUp"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group align-items-end">
            <CCol :col="6">
              <CInput
                label="Apakah Anda Mempunya Usaha Lain?"
                class="mb-0"
                placeholder="Apakah Anda Mempunya Usaha Lain?"
                v-model.trim="isHaveOtherBusiness"
                disabled
              />
            </CCol>
            <CCol
              v-if="agentData.other_business"
              :col="6"
            >
              <CInput
                class="mb-0"
                v-model.trim="agentData.other_business"
                disabled
              />
            </CCol>
          </CRow>
        </CCardBody>

        <CCardHeader><strong>UTM</strong></CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Source"
                class="mb-0"
                placeholder="UTM Source"
                v-model.trim="agentData.utm_source"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Medium"
                class="mb-0"
                placeholder="UTM Medium"
                v-model.trim="agentData.utm_medium"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Campaign"
                class="mb-0"
                placeholder="UTM Campaign"
                v-model.trim="agentData.utm_campaign"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Term"
                class="mb-0"
                placeholder="UTM Term"
                v-model.trim="agentData.utm_term"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Content"
                class="mb-0"
                placeholder="UTM Content"
                v-model.trim="agentData.utm_content"
                disabled
              />
            </CCol>
          </CRow>
        </CCardBody>

        <CCardHeader></CCardHeader>

        <CCardBody>
          <CRow class="form-group">
            <CCol :col="6" v-if="agentData.referral_code !== undefined">
              <CInput
                label="Referral Code"
                class="mb-0"
                placeholder="Referral Code"
                v-model.trim="agentData.referral_code"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Created Date"
                class="mb-0"
                placeholder="Created Date"
                v-model.trim="agentData.created_at"
                disabled
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol :col="6">
              <CInput
                label="Status Pengajuan"
                class="mb-0"
                v-model.trim="agentData.flag"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CSelect
                placeholder="Please select"
                label="Action"
                :options="optionsFlag"
                type="options"
                required
                @change="handleChooseFlag"
              />
            </CCol>
          </CRow>
          <CRow
            v-for="(item, index) of imageAgent"
            class="form-group"
            :key="`${item.label}-${index}`"
          >
            <CCol :col="3">
              <span>{{ item.label }}</span>
            </CCol>
            <CCol :col="6">
              <a
                v-if="Boolean(item.src)"
                :href="item.src"
                target="_blank"
              >
                <img
                  :src="item.src"
                  :alt="item.alt"
                  class="attachment-support"
                >
            </a>
              <p v-else>{{ item.error }}</p>
            </CCol>
          </CRow>
          <CRow>
            <CCol
              :col="6"
              v-if="
                flag.includes('1') ||
                flag.includes('2') ||
                flag.includes('3') ||
                flag.includes('4')
              "
            >
              <CSelect
                placeholder="Please select"
                label="Reason"
                :options="optionsFollowUpReason"
                type="options"
                required
                @change="handleReason"
              />
            </CCol>
            <CCol :col="6" v-if="flag.includes('APPROVE')">
              <CSelect
                placeholder="Please select"
                label="Reason Approve"
                :options="optionsApprove"
                type="options"
                required
                @change="handleReason"
              />
            </CCol>
            <CCol :col="6" v-if="flag === 'REJECT'">
              <CSelect
                placeholder="Please select"
                label="Reason Reject"
                :options="optionsReject"
                type="options"
                required
                @change="handleReason"
              />
            </CCol>
          </CRow>
          <CRow :col="12" v-if="flag === 'TOP UP'" class="mb-3">
            <CCol v-for="(request, index) in requestData" :key="index">
              <CInput
                :label="request.label"
                class="mb-2"
                required
                :placeholder="request.label"
                v-model="request.value"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol :col="6" v-if="flag2 === 'Other'">
              <CInput
                label="Note"
                class="mb-0"
                required
                placeholder="Input Some Reason"
                @change="handleReason"
              />
            </CCol>
          </CRow>
          <CRow class="mb-4 mt-2">
            <CCol :col="12">
              <div class="d-flex justify-content-center">
                <CButton color="info" class="mt-2" @click="visible = !visible"
                  >Upload File</CButton
                >
              </div>
              <CCard v-if="visible" class="mt-3">
                <CCardBody>
                  <CRow :col="12">
                    <CCol>
                      <div v-for="(request, index) in requestFile" :key="index">
                        <CInputFile
                          :label="request.label"
                          horizontal
                          class="mb-3"
                          accept="image/png, image/jpg, image/jpeg, image/svg+xml"
                          @change="handleFile($event, index)"
                        />
                      </div>
                    </CCol>
                  </CRow>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton color="success" class="float-right" @click="update"
                >Submit</CButton
              >
            </CCol>
          </CRow>
        </CCardFooter>
        <CCardBody>
          <div class="judul">
            <strong>History Approval</strong>
          </div>
          <CDataTable hover :items="agentData.histories" :fields="fields">
            <template #whatsapp="data">
              <td>
                <CButton
                  color="success"
                  class="float-left"
                  @click="toWhatsApp(data)"
                  ><CIcon name="cil-chat-bubble"></CIcon>
                </CButton>
              </td>
            </template>
            <template #attachment_registration="data">
              <td>
                <div v-if="data.item.attachment_registration !== undefined">
                  <div
                    v-if="
                      data.item.attachment_registration[0] == '' &&
                      data.item.attachment_registration[1] == '' &&
                      data.item.attachment_registration[2] == '' &&
                      data.item.attachment_registration[3] == '' &&
                      data.item.attachment_registration[4] == '' &&
                      data.item.attachment_registration[5] == '' &&
                      data.item.attachment_registration[6] == '' &&
                      data.item.attachment_registration[7] == ''
                    "
                  >
                    No File Attachment
                  </div>
                  <div v-else>
                    <select
                      class="select-custom"
                      required
                      @change="handleDownloadAttachment"
                      v-model="selectedFile"
                    >
                      <option hidden selected>{{ titleSelectedFile }}</option>
                      <option
                        v-for="(file, index) in requestFile"
                        :value="data.item.attachment_registration[index]"
                        :hidden="
                          data.item.attachment_registration[index] === '' ||
                          data.item.attachment_registration[index] === undefined
                        "
                        :key="index"
                      >
                        {{ file.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div v-else>No File Attachment</div>
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import jwt from "jsonwebtoken";
import ACCOUNT_GROUP from "../../../../app/enum/groups.js";
import { AGENT_FLAG, BOOLEAN_STRING } from "./app/enum/index.js";
import AgentRegistrationUseCase from "./app/usecase/index.js";

export default {
  name: "FollowUpDetail",
  data() {
    return {
      agentData: {},
      optionsFlag: ["FOLLOW UP", "APPROVE FOLLOW UP", "REGISTER", "REJECT"],
      optionsApprove: ["Calon agen sudah melengkapi data"],
      optionsFollowUpReason: [
        "Calon agen masih mempertimbangkan",
        "Calon agen masih mencari lokasi alternatif",
        "Calon agen tidak dapat dihubungi",
        "Calon agen tidak melengkapi data",
        "On queuing follow up",
        "Tidak ada feedback dari calon agen",
      ],
      optionsReject: [
        "Calon agen hanya mencari informasi",
        "Calon agen keberatan dengan S&K Keagenan (Deposit)",
        "Calon agen keberatan dengan S&K Keagenan (Drop Off)",
        "Calon agen keberatan dengan S&K Keagenan (Marketplace)",
        "Calon agen keberatan dengan S&K Keagenan (Operasional)",
        "Calon agen keberatan dengan S&K Keagenan (Target)",
        "Calon agen memiliki usaha sejenis",
        "Calon agen tidak melengkapi data",
        "Calon agen tidak memiliki lokasi",
        "Lokasi berdekatan dengan POS lain",
        "Lokasi kurang strategis",
        "Lokasi terlalu jauh dari perwakilan",
        "Nomor tidak dapat dihubungi",
        "Tidak ada perwakilan di daerah tersebut",
      ],
      items: [],
      flag: "",
      flag2: "",
      visible: false,
      reason: "",
      fields: [
        { key: "action", label: "Action" },
        { key: "flag", label: "Status Pengajuan" },
        { key: "reason", label: "Reason" },
        { key: "created_by", label: "Created By" },
        { key: "created_at", label: "Created Date" },
        { key: "attachment_registration", label: "File Attachment" },
        { key: "whatsapp", label: "WhatsApp" },
      ],
      requestFile: [
        { label: "Fotokopi Akte Perusahaan", key: "attachment_deed", file: "" },
        { label: "Fotokopi SIUP", key: "attachment_siup", file: "" },
        { label: "Fotokopi TDP", key: "attachment_tdp", file: "" },
        { label: "Fotokopi NPWP", key: "attachment_npwp", file: "" },
        {
          label: "Fotokopi KTP Pemilik/Direktur",
          key: "attachment_ktp",
          file: "",
        },
        {
          label: "Fotokopi Buku Rekening",
          key: "attachment_bank_account",
          file: "",
        },
        {
          label: "Titik koordinat/foto lokasi",
          key: "attachment_location",
          file: "",
        },
        {
          label: "Foto Tempat Perusahaan",
          key: "attachment_business_place",
          file: "",
        },
      ],
      requestData: [
        { label: "Pos Name", key: "pos_name", value: "" },
        { label: "Pos Code", key: "pos_code", value: "" },
      ],
      titleSelectedFile: "List File Attachment",
      selectedFile: "",
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      isPickup: BOOLEAN_STRING.NO,
      isLogistic: BOOLEAN_STRING.NO,
      isOlshop: BOOLEAN_STRING.NO,
      isDropOff: BOOLEAN_STRING.NO,
      isTopUp: BOOLEAN_STRING.NO,
      isHaveOtherBusiness: BOOLEAN_STRING.NO
    };
  },
  async mounted() {
    this.authentication();
    await this.getDataByID();
    this.validateBoolean();
    this.selectedFile = this.titleSelectedFile;
  },
  computed: {
    imageAgent() {
      return [
        {
          label: 'KTP',
          alt: 'Foto KTP agent',
          src: this.agentData.agent_identity,
          error: 'Foto KTP tidak ada'
        },
        {
          label: 'Lokasi Tampak Depan',
          alt: 'Foto lokasi tampak depan',
          src: this.agentData.agent_location_front,
          error: 'Foto lokasi tampak depan tidak ada'
        },
        {
          label: 'Lokasi Tampak Dalam',
          alt: 'Foto lokasi tampak dalam',
          src: this.agentData.agent_location_in,
          error: 'Foto lokasi tampak dalam tidak ada'
        },
      ]
    }
  },
  methods: {
    async getDataByID() {
      let agentID = this.$route.params.id;
      try {
        const { data, err } = await AgentRegistrationUseCase.getOne(agentID);
        if (err) {
          this.err = err;
          await this.$swal.fire({
            icon: "error",
            text: err,
          });
        } else {
          this.err = "";
          if (data) {
            this.agentData = data;
            this.validateListFlag();
            this.items = [this.agentData];
          }
        }
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err,
        });
      }
    },
    validateBoolean() {
      if (this.agentData.is_pickup) {
        this.isPickup = BOOLEAN_STRING.YES;
      }
      if (this.agentData.is_logistic) {
        this.isLogistic = BOOLEAN_STRING.YES;
      }
      if (this.agentData.is_olshop) {
        this.isOlshop = BOOLEAN_STRING.YES;
      }
      if (this.agentData.is_drop_off) {
        this.isDropOff = BOOLEAN_STRING.YES;
      }
      if (this.agentData.is_top_up) {
        this.isTopUp = BOOLEAN_STRING.YES;
      }
      if (this.agentData.is_have_other_business) {
        this.isHaveOtherBusiness = BOOLEAN_STRING.YES;
      }
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === ACCOUNT_GROUP.NPOS ||
        data.account_group === ACCOUNT_GROUP.ADMIN ||
        data.account_group === ACCOUNT_GROUP.ADMINISTRATOR
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    goBack() {
      this.usersOpened
        ? this.$router.go(-1)
        : this.$router.push({ path: "/agent/follow-up" });
    },
    handleReason(event) {
      this.reason = event.target.value;
    },
    handleChooseFlag(event) {
      event.target.value == AGENT_FLAG.REGISTER
        ? (this.flag = AGENT_FLAG.TOP_UP)
        : (this.flag = event.target.value);
    },
    handleFile(event, index) {
      this.requestFile[index].file = event[0];
    },
    handleDownloadAttachment(event) {
      window.open(event.target.value);
      this.selectedFile = this.titleSelectedFile;
    },
    validateListFlag() {
      if (this.agentData.flag !== AGENT_FLAG.APPROVE_FOLLOW_UP) {
        this.optionsFlag.splice(this.optionsFlag.length - 2, 1);
      }
      switch (this.agentData.flag) {
        case AGENT_FLAG.FOLLOW_UP:
          this.optionsFlag[0] = AGENT_FLAG.FOLLOW_UP_1;
          break;
        case AGENT_FLAG.FOLLOW_UP_1:
          this.optionsFlag[0] = AGENT_FLAG.FOLLOW_UP_2;
          break;
        case AGENT_FLAG.FOLLOW_UP_2:
          this.optionsFlag[0] = AGENT_FLAG.FOLLOW_UP_3;
          break;
        case AGENT_FLAG.FOLLOW_UP_3:
          this.optionsFlag[0] = AGENT_FLAG.FOLLOW_UP_4;
          break;
        case AGENT_FLAG.APPROVE_FOLLOW_UP:
          this.optionsFlag = this.optionsFlag.slice(2, 4);
          break;
        default:
          this.optionsFlag = this.optionsFlag.slice(1, 4);
      }
    },
    toWhatsApp() {
      window.open(`https://wa.me/${this.agentData.phone_number}`);
    },
    proccessFormData() {
      this.reason == "" && this.flag == AGENT_FLAG.TOP_UP
        ? (this.reason = AGENT_FLAG.REGISTER)
        : "";
      let formData = new FormData();
      formData.append("flag", this.flag);
      formData.append("reason", this.reason);
      formData.append("register_name", this.agentData.register_name);
      formData.append("register_address", this.agentData.register_address);
      formData.append("phone_number_two", this.agentData.phone_number_two);
      if (this.agentData.registration_type === "Badan Usaha") {
        formData.append("company_type", this.agentData.company_type);
        formData.append("company_chairman_name", this.agentData.company_chairman_name);
        formData.append("company_name", this.agentData.company_name);
        formData.append("company_address", this.agentData.company_address);
      }
      formData.append("building_location", this.agentData.building_location);
      formData.append("building_type", this.agentData.building_type);
      formData.append("building_status", this.agentData.building_status);
      formData.append("address_location", this.agentData.address_location);
      formData.append("province", this.agentData.province);
      formData.append("district", this.agentData.district);
      formData.append("sub_district", this.agentData.sub_district);
      formData.append("village", this.agentData.village);
      formData.append("latlong", this.agentData.latlong);
      this.requestData.forEach((form) => {
        formData.append(form.key, form.value);
      });
      this.requestFile.forEach((form) => {
        form.file ? formData.append(form.key, form.file) : "";
      });

      return formData;
    },
    async update() {
      let agentID = this.$route.params.id;

      await this.$swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        onOpen: async () => {
          this.$swal.showLoading();
          var formData = this.proccessFormData();
          try {
            const { err } = await AgentRegistrationUseCase.updateOne(
              formData,
              agentID
            );
            if (err) {
              this.$swal.close();
              await this.$swal.fire({
                icon: "error",
                text: err,
              });
            } else {
              this.$swal.fire({
                icon: "success",
                text: "Agent saved",
              });
              this.flag === AGENT_FLAG.TOP_UP
                ? this.$router.push({ path: `/agent/top-up` })
                : this.goBack();
            }
          } catch (err) {
            this.$swal.close();
            await this.$swal.fire({
              icon: "error",
              text: err,
            });
          }
        },
      });
    },
  },
};
</script>

<style scoped>
@import "./Agent.css";
</style>
